export default __webpack_public_path__ + "static/media/uploadEn2.584e068e.jpg";